import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=238b9d94&scoped=true&"
import script from "./videoPlay.ts?vue&type=script&lang=js&"
export * from "./videoPlay.ts?vue&type=script&lang=js&"
import style0 from "./videoPlay.less?vue&type=style&index=0&id=238b9d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b9d94",
  null
  
)

export default component.exports